import { differenceInCalendarDays, isThisMonth, setYear, startOfDay, } from "date-fns";
export const dateIsInCurrentMonth = (date, dateToCompare) => {
    return isThisMonth(setYear(date, Number(dateToCompare.getFullYear())));
};
/** @private */
export function isValidDate(day) {
    return !!(day && !Number.isNaN(day.getTime()) && day.getFullYear() > 999);
}
export function isDateOutsideRange({ day, fromDate, toDate, }) {
    const isDateAfter = toDate && differenceInCalendarDays(day, startOfDay(toDate)) > 0;
    const isDateBefore = fromDate && differenceInCalendarDays(startOfDay(fromDate), day) > 0;
    return isDateAfter || isDateBefore || false;
}
//# sourceMappingURL=check-dates.js.map